export default __webpack_public_path__ + "static/media/glitch36.0bec9973.png";